import API from '../../../lib/commons/api'

const UI_STATE_PATH = '/api/v1/ui_states'

/**
 * 画面(applicationFunctionUuid)に属さず、アプリ全体で共通に使う UI 状態のキー。
 * 画面ごとの UI 状態は画面側のキーと混ざらないよう applicationFunctionUuid つきで保存する。
 */
export type GlobalUiStateKey = 'AI_AGENT_CHAT_FAB_DISMISSED'

// ログインユーザー単位で保存する。テナント共通にしたい設定は現れていないため USER のみ扱う。
const USER_SCOPE = 'USER'

/**
 * ログインユーザーのアプリ全体共通の UI 状態を取得する。
 *
 * applicationFunctionUuid を送らないことで、保存先が特定の画面に紐づかなくなる。
 */
export const fetchGlobalUiState = async <T>(
  key: GlobalUiStateKey
): Promise<T | undefined> => {
  const response = await API.presentational.request('GET', UI_STATE_PATH, {
    key,
    scope: USER_SCOPE,
  })
  if (!response.json?.value) return undefined
  return JSON.parse(response.json.value) as T
}

export const saveGlobalUiState = async <T>(
  key: GlobalUiStateKey,
  value: T
): Promise<void> => {
  await API.presentational.request('POST', UI_STATE_PATH, {
    key,
    scope: USER_SCOPE,
    value: JSON.stringify(value),
  })
}
